export default {
	code: 'Code',
	name: 'Threat',
	catalog: 'Catalog',
	connectedRisks: 'Connected risks',
	score: 'Risk score',
	category: 'Category',
	impact: 'Impact area',
	description: 'Description',
	addName: 'Add threat name',
	addCode: 'Add threat code',
	addDescription: 'Add threat description',
	addThreat: 'Add new threat',
}
